import { Pipe, PipeTransform } from '@angular/core';
import {Channel} from './iptv_editor.component';
/**
 * Фильтрует список каналов в зависимости от выбранной группы
 */
@Pipe({
  name: 'filterGroup',
  // Необходимо, чтобы список каналов постоянно изменялся при изменении элемента в массиве.
  pure: false,
})
export class FilterGroupPipe implements PipeTransform {

  transform(value: Channel[], group_id?:number|null): Channel[] {
    return value.filter(
      item => item.group_id == group_id
   );
  }
}